export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "electricGraphData.worker.dda9f9277422c8db3e8f-306.worker.js");
}
